export const CHANGE_MINING_SCREEN = 'MINING_CHANGE_MINING_SCREEN'
export const REMOVE_PREV_SCREEN = 'MINING_REMOVE_PREV_SCREEN'
export const CREATE_QUESTION = 'MINING_CREATE_QUESTION'
export const SAVE_QUESTION_OK = 'MINING_SAVE_QUESTION_OK'
export const SAVE_QUESTION_ERROR = 'MINING_SAVE_QUESTION_ERROR'
export const GET_NEW_SIGNAL = 'MINING_GET_NEW_SIGNAL'
export const SET_NEW_SIGNAL = 'MINING_SET_NEW_SIGNAL'
export const GET_COUNT_DISPUTES = 'MINING_GET_COUNT_DISPUTES'
export const GET_COUNT_DISPUTES_SUCCESS = 'MINING_GET_COUNT_DISPUTES_SUCCESS'
export const GET_COUNT_DISPUTES_ERROR = 'MINING_GET_COUNT_DISPUTES_ERROR'

export const GET_OWN_QUESTIONS = 'MINING_GET_OWN_QUESTIONS'
export const GET_OWN_QUESTIONS_SUCCESS = 'MINING_GET_OWN_QUESTIONS_SUCCESS'
export const GET_OWN_QUESTIONS_ERROR = 'MINING_GET_OWN_QUESTIONS_ERROR'

export const changeMiningScreen = (miningScreen) => ({
  type: CHANGE_MINING_SCREEN,
  data: miningScreen,
})
export const removePrevScreen = () => ({
  type: REMOVE_PREV_SCREEN,
})
export const createQuestion = (question) => ({
  type: CREATE_QUESTION,
  data: question,
})
export const saveQuestionOk = () => ({
  type: SAVE_QUESTION_OK,
})
export const saveQuestionError = () => ({
  type: SAVE_QUESTION_ERROR,
})
export const getNewSignal = () => ({
  type: GET_NEW_SIGNAL,
})
export const setNewSignal = (signal) => ({
  type: SET_NEW_SIGNAL,
  data: signal,
})
export const getCountDisputes = () => ({
  type: GET_COUNT_DISPUTES,
})
export const getCountDisputesSuccess = (data) => ({
  type: GET_COUNT_DISPUTES_SUCCESS,
  data,
})
export const getCountDisputesError = (error) => ({
  type: GET_COUNT_DISPUTES_ERROR,
  error,
})

export const getOwnQuestions = () => ({
  type: GET_OWN_QUESTIONS,
})

export const getOwnQuestionsSuccess = (data) => ({
  type: GET_OWN_QUESTIONS_SUCCESS,
  data,
})

export const getOwnQuestionsError = (error) => ({
  type: GET_OWN_QUESTIONS_ERROR,
  error,
})
